import { useQuery } from '@tanstack/react-query';
import { getRelativeURLWithParams } from 'utils/url';
import { LOCATIONS } from 'constants/endpoints.api';
import { REQUEST_ID_HEADER } from 'constants/headers';
import { getRequestId } from 'utils/requestId';
import { LocationsResponse } from './types';

export interface LocationsQueryParams {
  latitude?: number;
  longitude?: number;
  search?: string;
  storeId: string;
  locale: string;
  extendedList?: boolean;
}

export const useLocationsQuery = ({
  latitude,
  longitude,
  search,
  storeId,
  locale,
  extendedList = false
}: LocationsQueryParams) =>
  useQuery<LocationsResponse>({
    // TODO: dependencies missing in queryKey: latitude, longitude, extendedList
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['locations', search, storeId, locale],
    queryFn: async () => {
      const url = getRelativeURLWithParams(LOCATIONS, {
        latitude,
        longitude,
        address: search,
        extendedList,
        storeId,
        locale
      });

      const res = await fetch(url, {
        headers: { [REQUEST_ID_HEADER]: getRequestId() }
      });

      return res.json();
    },
    // Query config
    enabled: !!search
  });
